<template>
	<div>
		<div class="logReg__swapper">
			<div :class="['wrapper', stateRegistration ? 'is-active' : '']">
				<div class="arrow"></div>
				<v-btn
					text
					:ripple="false"
					class="logReg__btn"
					@click="setRegistration"
				>
					{{ $t('buyout.logRegSwapper.register') }}
				</v-btn>
			</div>
			<div :class="['wrapper', !stateRegistration ? 'is-active' : '']">
				<div class="arrow"></div>
				<v-btn
					text
					:ripple="false"
					class="logReg__btn"
					@click="stateRegistration = false"
				>
					{{ $t('buyout.logRegSwapper.login') }}
				</v-btn>
			</div>
		</div>
		<template v-if="!stateRegistration">
			<slot name="isRegistration">
				<login-form class="logReg__login">
					<template slot="loginBuyout">
        		<slot name="loginBuyout" />
      		</template>
				</login-form>
			</slot>
		</template>
		<template v-if="stateRegistration">
			<slot name="isNotRegistration">
				<online-buyout-only class="logReg__reg" />
			</slot>
		</template>
	</div>
</template>
<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import LoginForm from '../LoginForm/App';
import OnlineBuyoutOnly from '../OnlineBuyoutOnly/App';
import { config } from '../../../config/buyout';
import isEqual from 'lodash/isEqual';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';

export default {
	name: 'LogRegSwapper',
	components: { OnlineBuyoutOnly, LoginForm },
	computed: {
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.IS_REGISTRATION,
			GETTER_TYPES.GET_SELECTED_MODEL,
			GETTER_TYPES.GET_SELECTED_COLOR,
			GETTER_TYPES.GET_SELECTED_BRAND,
			GETTER_TYPES.GET_SELECTED_CATEGORY
		]),
		stateRegistration: {
			get() {
				return this[GETTER_TYPES.IS_REGISTRATION];
			},
			set(v) {
				this[MUTATION_TYPES.SET_IS_REGISTRATION](v);
			}
		}
	},
	methods: {
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_IS_REGISTRATION,
			MUTATION_TYPES.SET_IS_LOGGED_IN,
			MUTATION_TYPES.SET_BUYOUT_STATE_IDENTIFIER
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.RESET_APPRAISAL,
			ACTION_TYPES.LOAD_COLORS
		]),
		async setRegistration() {
			this.stateRegistration = true;
			this[MUTATION_TYPES.SET_IS_LOGGED_IN](false);
			this[ACTION_TYPES.RESET_APPRAISAL]();
			this[MUTATION_TYPES.SET_BUYOUT_STATE_IDENTIFIER](null);
			if (this[GETTER_TYPES.GET_SELECTED_MODEL])
				this[ACTION_TYPES.LOAD_COLORS]();
			if (config.isURLHandlingEnabled) {
				let params = {
					category: this[GETTER_TYPES.GET_SELECTED_CATEGORY]?.seo_name,
					brand: this[GETTER_TYPES.GET_SELECTED_BRAND]?.seo_name,
					model: this[GETTER_TYPES.GET_SELECTED_MODEL]?.seo_name,
					color: this[GETTER_TYPES.GET_SELECTED_COLOR]?.seo_name,
					quality: undefined //TODO: make it alive
				}

				// this if prevent redundant redirection
				if (!isEqual(this.$route.params, params))
					this.$router.replace({
						name: 'home',
						params: params
					});
			}
		}
	}
}
</script>
